import barba from '@barba/core';
import { gsap } from "gsap";



function page404()
{
    const base = document.querySelector(".theEye");

    if (base != null)
    {
        let mouse = base.createSVGPoint();

        const theEye = createEye("#eyeBall");

        let requestId = null;

        window.addEventListener("mousemove", onMouseMove)

        function onFrame()
        {
            const point = mouse.matrixTransform(base.getScreenCTM().inverse());
            theEye.moveTo(point);
            requestId = null;
        }

        function onMouseMove(event)
        {
            mouse.x = event.clientX;
            mouse.y = event.clientY;

            if (!requestId)
            {
                requestId = requestAnimationFrame(onFrame);
            }
        }

        function createEye(selector)
        {
            const element = document.querySelector(selector);
            const maxX = 115;
            const minX = -115;
            const maxY = 55;
            const minY = -55;

            gsap.set(element, {transformOrigin: "center"});

            const bbox = element.getBBox();
            const centerX = bbox.x + bbox.width / 2;
            const centerY = bbox.y + bbox.height / 2;

            function moveTo(point)
            {
                let dx = point.x - centerX;
                let dy = point.y - centerY;
                
                if (dx > maxX)
                {
                    dx = maxX;
                }
                else if (dx < minX)
                {
                    dx = minX;
                }

                if (dy > maxY)
                {
                    dy = maxY;
                }
                else if (dy < minY)
                {
                    dy = minY;
                }
        
                gsap.to(element, {x: dx, y: dy, duration: 0.3});
            }

            return { element: element, moveTo: moveTo };
        }
    }
}


barba.hooks.enter((data) => {

    page404();
    
});


page404();